export class Sanitizer{
    public static SanitizeStringArray(value, clearWhenNotArray:boolean=true):string[]
    {
        if(value==null)
            return [];

        if(!Array.isArray(value))
        {
            if(clearWhenNotArray)
                return [];
            return [Sanitizer.SanitizeString(value)];
        }else
            return value.map(x=>Sanitizer.SanitizeString(x));

    }


    public static SanitizeString(value,defaultValue:string='') {
        if(value==null||Array.isArray(value))
            return defaultValue;

        if(value.toString==null|| typeof value =="object")
            return defaultValue;

        return value.toString();

    }

    static GetValueFromPath(obj:any,path:string[],defaultValue:any='')
    {
        if(obj==null)
            return defaultValue;

        let nextProperty='';
        while ((nextProperty=path.shift())!=null)
        {
            if(obj[nextProperty]==undefined)
                return defaultValue;

            obj=obj[nextProperty];
        }

        return obj;
    }

    static GetStringValueFromPath(obj:any,path:string[],defaultValue:string='')
    {
        let value=Sanitizer.GetValueFromPath(obj,path,null);
        if(value==null)
            return defaultValue;

        return Sanitizer.SanitizeString(value);
    }

    static SanitizeNumber(value: any,defaultValue:number=0) {
        if(value==null||Array.isArray(value)||value==='')
            return defaultValue;

        value=Number(value);
        if(isNaN(value))
            return defaultValue;

        return value;
    }

    static SanitizeBoolean(value: any, defaultValue: any=false) {
        if(value===null)
            return defaultValue;

        if(typeof value =='boolean')
        {
            return value;
        }

        if(!isNaN(Number(value)))
        {
            return value!=0;
        }

        return defaultValue;
    }
}